// src/components/common/PageHero.jsx
import React from "react";
import { FiChevronRight } from "react-icons/fi";

export default function PageHero({
  title,
  imageUrl = "https://www.mairie-bruges.fr/media/cache/640x150/uploads/page/5c0529de0cd4a582931665.jpg",
  crumbs = [],
  heightClass = "h-56 md:h-72",
}) {
  return (
    <header className={`relative w-full ${heightClass} overflow-hidden`}>
      {/* Image */}
      <img
        src={imageUrl}
        alt={title || "Bannière"}
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />

      {/* Dégradé uniquement sur le bas (80% de la hauteur) */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[80%] bg-gradient-to-t from-slate-900/80 via-slate-900/40 to-transparent" />

      {/* Contenu (fil d'Ariane) */}
      <div className="relative z-10 mx-auto max-w-[1200px] h-full px-4 sm:px-6 flex items-end">
        <div className="pb-4 md:pb-6 w-full font-semibold text-white">
          {crumbs?.length > 0 && (
            <nav aria-label="Fil d’Ariane" className="text-sm">
              <ol className="flex flex-wrap items-center gap-1 text-white">
                {crumbs.map((c, i) => (
                  <li key={`${c.label}-${i}`} className="flex items-center">
                    {i > 0 && (
                      <FiChevronRight className="mx-2 opacity-90" aria-hidden />
                    )}
                    {c.href ? (
                      <a
                        href={c.href}
                        className="text-white hover:underline"
                      >
                        {c.label}
                      </a>
                    ) : (
                      <span className="text-white/95">{c.label}</span>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
}
